// Global Product / Variant bulk-selection cap (PCS-11328). Separate from CSV export limit.
export const PRODUCT_BULK_SELECTION_LIMIT = 50000;
